export class ApiError extends Error {

    constructor(public type: string, m: string) {
        super(m)
    }
}